import * as rules from 'vee-validate/dist/rules'
import { configure, extend, localize, ValidationObserver, ValidationProvider } from 'vee-validate'
import ar from 'vee-validate/dist/locale/ar.json'
import Vue from 'vue'

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
})

localize('ar', ar)

configure({
  locale: 'ar',
  mode: 'aggressive'
})

extend('arabic_name', {
  validate (value) {
    const v = String(value == null ? '' : value).trim()
    if (!v) return 'الاسم بالعربية مطلوب.'
    if (/[a-zA-Z]/.test(v)) return 'لا يُسمح بالحروف الانجليزية في هذا الحقل'
    if (!/[\u0600-\u06FF]/.test(v)) return 'يجب إدخال حروف عربية في هذا الحقل'
    if (v.length < 2) return 'يجب أن يكون الاسم حرفين على الأقل'
    if (v.length > 200) return 'الاسم طويل جداً (الحد الأقصى 200 حرف)'
    return true
  }
})

extend('english_name', {
  validate (value) {
    const v = String(value == null ? '' : value).trim()
    if (!v) return 'الاسم بالإنجليزية مطلوب.'
    if (/[\u0600-\u06FF]/.test(v)) return 'لا يُسمح بالحروف العربية في هذا الحقل'
    if (!/[a-zA-Z]/.test(v)) return 'يجب إدخال حروف إنجليزية في هذا الحقل'
    if (v.length < 2) return 'يجب أن يكون الاسم حرفين على الأقل'
    if (v.length > 200) return 'الاسم طويل جداً (الحد الأقصى 200 حرف)'
    return true
  }
})

Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)
